export default __webpack_public_path__ + "static/apple-touch-icon-9ef1aa9bbd2da090a0049c38605b09c1.png";